<script setup lang="ts">
import { nextTick, ref } from 'vue'

import { useKeepTabbingFocus } from '../../../composables/use-keep-tabbing-focus'

const { keepTabbingFocus, removeTabbingEventListeners } = useKeepTabbingFocus()

const searchPhrase = ref('')
const headerSearchOpener = ref<HTMLButtonElement | null>(null)
const headerSearchForm = ref<HTMLFormElement | null>(null)
const headerSearchInput = ref<HTMLInputElement | null>(null)

const keepTabbingFocusInHeaderSearch = () => {
  nextTick(() => {
    if (!headerSearchForm.value) return
    removeTabbingEventListeners()
    keepTabbingFocus(headerSearchForm.value, ['input, button:not(.icon-close)'], 0, () => {
      removeTabbingEventListeners()
      toggleSearch()
      headerSearchOpener.value?.focus()
    })
  })
}

const toggleSearch = () => {
  const showSearch = document.body.classList.toggle('bx-js-show-search')
  if (showSearch) {
    headerSearchInput.value?.focus()
    keepTabbingFocusInHeaderSearch()
  }
}

const submitSearch = () => {
  window.location.href = `/suche?query=${encodeURIComponent(searchPhrase.value.trim())}`
}
</script>

<template>
  <div class="bx-header__search bx-typo--header-search">
    <button ref="headerSearchOpener"
            aria-label="Suche öffnen"
            class="bx-header__search-toggle icon icon-search"
            @click="toggleSearch()"
            @keyup.enter="toggleSearch()">
      <svg><use href="#search" /></svg>
    </button>
    <form ref="headerSearchForm"
          class="bx-form bx-typo--form bx-form--search-header bx-typo--form-search-header"
          onsubmit="return false;"
          @submit="submitSearch()">
      <input id="bx-header-search-input"
             ref="headerSearchInput"
             v-model="searchPhrase"
             type="search"
             class="bx-form__input"
             title="Worauf hast du heute Lust?"
             placeholder="Worauf hast du heute Lust?">
      <button aria-label="Suchen"
              class="bx-header__search-submit icon icon-search">
        <svg><use href="#search" /></svg>
      </button>
      <button aria-label="Suche schliessen"
              class="bx-header__search-close icon icon-close"
              type="button"
              @click="toggleSearch()"
              @keyup.enter="toggleSearch()">
        <svg><use href="#close" /></svg>
      </button>
    </form>
  </div>
</template>
